import React, { useState } from "react";
import Accordion from "@mui/material/Accordion";
import AccordionDetails from "@mui/material/AccordionDetails";
import AccordionSummary from "@mui/material/AccordionSummary";
import Typography from "@mui/material/Typography";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import Avatar from "@mui/material/Avatar";
import Tooltip from "@mui/material/Tooltip";
import {
  getIsNeutralSvg,
  getLocationEnableDisableIcon,
  NotificationBellSvg,
  POIsSvg,
  ResultIconWithRank,
  SadIcon,
} from "../svgs/SVGs";
import {
  formatDate,
  GetTeamNameAndIdentifier,
  stringAvatar,
} from "../utility/UtilFunctions";
import {
  Paper,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
} from "@mui/material";
import StagePoisComponent from "./StagePoisComponent";

function TeamDetails({ expanded, handleChange, accordionKey, journeyData }) {
  const [resultDetailsVisible, setResultDetailsVisible] = useState(false);
  const [poisDetailsVisible, setPoisDetailsVisible] = useState(false);
  const [notificationDetailsVisible, setNotificationDetailsVisible] =
    useState(false);

  const [stagePOIsTotalPoints, setStageTotalPOIsPoints] = useState(0);

  const handlePOIsClick = () => {
    setPoisDetailsVisible((prevState) => !prevState);
    setResultDetailsVisible(false);
    setNotificationDetailsVisible(false);
  };

  const handleNotificationsClick = () => {
    setNotificationDetailsVisible((prevState) => !prevState);
    setResultDetailsVisible(false);
    setPoisDetailsVisible(false);
  };

  const handleResultDetailsClick = () => {
    setResultDetailsVisible((prevState) => !prevState);
    setNotificationDetailsVisible(false);
    setPoisDetailsVisible(false);
  };

  return (
    <div style={{ marginBottom: "5px" }} className="mb-3">
      <Accordion
        expanded={expanded === accordionKey}
        onChange={handleChange(accordionKey)}
      >
        <AccordionSummary
          expandIcon={<ExpandMoreIcon />}
          aria-controls="panel1bh-content"
          id="panel1bh-header"
        >
          <div className="row">
            <div className="col-md-12">
              <div className="d-flex align-items-center p-2 rounded">
                <img
                  src={journeyData.TeamImageUrl}
                  alt="Profile"
                  className="rounded-circle me-3"
                  style={{
                    width: "60px",
                    height: "60px",
                    border: `5px solid ${journeyData.TrailColor}`,
                  }}
                />
                <span className="fw-semibold">
                  {GetTeamNameAndIdentifier(journeyData.TeamName) &&
                    GetTeamNameAndIdentifier(journeyData.TeamName).teamName}
                  <br />
                  <span style={{ fontSize: "12px", marginLeft: "5px" }}>
                    {/* {journeyData.Drivers?.SummaryData?.[0]?.["TeamName"]} */}
                    {GetTeamNameAndIdentifier(journeyData.TeamName) &&
                      GetTeamNameAndIdentifier(journeyData.TeamName).identifier}
                  </span>
                </span>
              </div>

              {journeyData.ResultData?.Disqualified && (
                <>
                  <div className="row">
                    <div className="col-md-4 d-flex align-items-center rounded">
                      <span
                        style={{
                          color: "white",
                          backgroundColor: "red",
                          fontSize: "12px",
                          fontWeight: "800",
                          borderRadius: "10px",
                          padding: "5px",
                          display: "inline",
                          border: "1px solid black",
                        }}
                      >
                        {journeyData.ResultData?.Disqualified
                          ? "DISQUALIFIED"
                          : ""}
                      </span>
                    </div>
                    <div className="col-md-8 d-flex align-items-center rounded">
                      <Tooltip
                        title={journeyData.ResultData?.DisqualifiedReason}
                      >
                        <span
                          style={{
                            color: "red",
                            backgroundColor: "white",
                            fontSize: "12px",
                            fontWeight: "500",
                            borderRadius: "10px",
                            padding: "5px",
                            border: "1px solid black",
                            whiteSpace: "nowrap",
                            overflow: "hidden",
                            textOverflow: "ellipsis",
                            display: "inline-block",
                          }}
                        >
                          {journeyData.ResultData?.DisqualifiedReason ===
                          "admin.over.max.time.disqaulification"
                            ? "Over Max Time"
                            : journeyData.ResultData?.DisqualifiedReason}
                        </span>
                      </Tooltip>
                    </div>
                  </div>
                </>
              )}
            </div>
          </div>
        </AccordionSummary>
        <AccordionDetails>
          <div className="row">
            <div className="col-md-12 col-sm-12">
              <div className="card-body text-center p-1">
                {journeyData.ResultData?.Disqualified
                  ? SadIcon()
                  : journeyData?.ResultData &&
                    ResultIconWithRank(
                      journeyData?.ResultData?.FinalRank,
                      "65px"
                    )}
                <Tooltip title="Driving Status">
                  <h4 className="card-title">{journeyData.StageStatus}</h4>
                </Tooltip>
                <p style={{ fontSize: "10px" }}>{journeyData.TeamAssetId}</p>
                <div style={{ marginTop: "-5px" }}>
                  <Tooltip title="HideFromMap = False">
                    {getLocationEnableDisableIcon(journeyData.HideFromMap)}
                  </Tooltip>
                  <Tooltip title="IsNeutral = False">
                    {getIsNeutralSvg(journeyData.IsNeutral)}
                  </Tooltip>
                </div>
              </div>
              {/* driver area */}
              <div className="row p-1">
                <div className="col-md-12 col-sm-12">
                  <Tooltip
                    title={
                      journeyData.Drivers?.SummaryData?.[0]?.["Expo Token"] ===
                      ""
                        ? "Driver not Logged In"
                        : "Driver Logged In"
                    }
                  >
                    <div
                      className="d-flex align-items-center p-2 rounded"
                      style={{
                        border:
                          journeyData.Drivers?.SummaryData?.[0]?.[
                            "Expo Token"
                          ] === ""
                            ? "2px solid red"
                            : "2px solid green",
                      }}
                    >
                      {/* Profile Picture */}

                      {journeyData.Drivers?.SummaryData?.[0]?.DriveImageUrl &&
                      journeyData.Drivers.SummaryData[0].DriveImageUrl.includes(
                        "default-image"
                      ) ? (
                        <Avatar
                          {...stringAvatar(
                            journeyData.Drivers?.SummaryData?.[0]?.[
                              "Driver Name"
                            ]
                          )}
                          style={{ alignSelf: "center", marginTop: "5px" }}
                        />
                      ) : (
                        <img
                          src={
                            journeyData.Drivers?.SummaryData?.[0]?.DriveImageUrl
                          }
                          alt="Profile"
                          className="rounded-circle me-3"
                          style={{ width: "40px", height: "40px" }}
                        />
                      )}

                      {/* Name */}
                      <span className="fw-semibold">
                        {journeyData.Drivers?.SummaryData?.[0]?.["Driver Name"]}
                      </span>
                    </div>
                  </Tooltip>
                </div>
                <div className="col-md-12 col-sm-12">
                  <Tooltip
                    title={
                      journeyData.Drivers?.SummaryData?.[1]?.["Expo Token"] ===
                      ""
                        ? "Driver not Logged In"
                        : "Driver Logged In"
                    }
                  >
                    <div
                      className="d-flex align-items-center p-2 rounded"
                      style={{
                        border:
                          journeyData.Drivers?.SummaryData?.[0]?.[
                            "Expo Token"
                          ] === ""
                            ? "2px solid red"
                            : "2px solid green",
                      }}
                    >
                      {/* Profile Picture */}

                      {journeyData.Drivers?.SummaryData?.[1]?.DriveImageUrl &&
                      journeyData.Drivers.SummaryData[1].DriveImageUrl.includes(
                        "default-image"
                      ) ? (
                        <Avatar
                          {...stringAvatar(
                            journeyData.Drivers?.SummaryData?.[1]?.[
                              "Driver Name"
                            ]
                          )}
                          style={{ alignSelf: "center", marginTop: "5px" }}
                        />
                      ) : (
                        <img
                          src={
                            journeyData.Drivers?.SummaryData?.[1]?.DriveImageUrl
                          }
                          alt="Profile"
                          className="rounded-circle me-3"
                          style={{ width: "40px", height: "40px" }}
                        />
                      )}

                      {/* Name */}
                      <span className="fw-semibold">
                        {journeyData.Drivers?.SummaryData?.[1]?.["Driver Name"]}
                      </span>
                    </div>
                  </Tooltip>
                </div>
              </div>
              <table class="table">
                <tbody>
                  <tr>
                    <th>Time</th>
                    <td>{journeyData.ReactDashboardDisplayStart}</td>
                    <td>{journeyData.ReactDashboardDisplayFinish}</td>
                  </tr>
                  <tr>
                    <th>Duration</th>
                    <td colSpan={2}>{journeyData.DisplayDrivingTime}</td>
                  </tr>
                  <tr>
                    <th>Odometer</th>
                    <td>{journeyData.StartOdometer}</td>
                    <td>{journeyData.FinishOdometer}</td>
                  </tr>
                  <tr>
                    <th>Distance</th>
                    <td colSpan={2}>{journeyData.DisplayDistanceCovered}</td>
                  </tr>
                  <tr>
                    <th>Extras</th>
                    <td colSpan={2}>
                      <span onClick={handlePOIsClick}>
                        <Tooltip title="Acquired POIs">{POIsSvg()}</Tooltip>
                      </span>
                      <span onClick={handleNotificationsClick}>
                        <Tooltip title="Received Notifications">
                          {NotificationBellSvg()}
                        </Tooltip>
                        {/* {DirectionalCarSVG("N")} */}
                      </span>
                      <span
                        style={{ cursor: "pointer" }}
                        onClick={handleResultDetailsClick}
                      >
                        <Tooltip title="Result Details">
                          {ResultIconWithRank("-")}
                        </Tooltip>
                      </span>
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
          {resultDetailsVisible && (
            <TableContainer component={Paper}>
              <Table
                sx={{ minWidth: 550 }}
                size="small"
                aria-label="notifications table"
              >
                <TableHead>
                  <TableRow style={{ backgroundColor: "#cccccc" }}>
                    <TableCell colSpan={6}>Distance Calculations</TableCell>
                  </TableRow>
                </TableHead>
                <TableBody>
                  <TableRow>
                    <TableCell>Start KM</TableCell>
                    <TableCell></TableCell>
                    <TableCell></TableCell>
                    <TableCell></TableCell>
                    <TableCell align="right">
                      {journeyData?.ResultData?.StartOdometer.toFixed(2)}
                    </TableCell>
                    <TableCell></TableCell>
                  </TableRow>
                  <TableRow>
                    <TableCell>End KM</TableCell>
                    <TableCell></TableCell>
                    <TableCell></TableCell>
                    <TableCell></TableCell>
                    <TableCell align="right">
                      {journeyData?.ResultData?.FinishOdometer.toFixed(2)}
                    </TableCell>
                    <TableCell></TableCell>
                  </TableRow>
                  <TableRow>
                    <TableCell>Distance</TableCell>
                    <TableCell></TableCell>
                    <TableCell></TableCell>
                    <TableCell></TableCell>
                    <TableCell align="right">
                      {journeyData?.ResultData?.DistanceCovered.toFixed(2)}
                    </TableCell>
                    <TableCell></TableCell>
                  </TableRow>
                  <TableRow>
                    <TableCell>Joker Distance</TableCell>
                    <TableCell></TableCell>
                    <TableCell></TableCell>
                    <TableCell></TableCell>
                    <TableCell align="right">
                      {journeyData?.ResultData?.JokerDistance.toFixed(2)}
                    </TableCell>
                    <TableCell></TableCell>
                  </TableRow>
                  <TableRow>
                    <TableCell>Credit Distance</TableCell>
                    <TableCell></TableCell>
                    <TableCell></TableCell>
                    <TableCell></TableCell>
                    <TableCell align="right">
                      {journeyData?.ResultData?.CreditDistance.toFixed(2)}
                    </TableCell>
                    <TableCell></TableCell>
                  </TableRow>
                  <TableRow>
                    <TableCell>Final Distance</TableCell>
                    <TableCell></TableCell>
                    <TableCell></TableCell>
                    <TableCell></TableCell>
                    <TableCell align="right">
                      {journeyData?.ResultData?.FinalRankingDistance.toFixed(2)}
                    </TableCell>
                    <TableCell></TableCell>
                  </TableRow>
                  <TableRow style={{ backgroundColor: "#f2f2f2" }}>
                    <TableCell>Distance Points</TableCell>
                    <TableCell></TableCell>
                    <TableCell></TableCell>
                    <TableCell></TableCell>
                    <TableCell></TableCell>
                    <TableCell align="right">
                      {journeyData?.ResultData?.PointsOnDistanceRank.toFixed(2)}
                    </TableCell>
                  </TableRow>
                </TableBody>
                <TableHead>
                  <TableRow style={{ backgroundColor: "#cccccc" }}>
                    <TableCell colSpan={6}>Pois Calculations</TableCell>
                  </TableRow>
                </TableHead>
                <StagePoisComponent
                  journeyData={journeyData}
                  setStageTotalPOIsPoints={setStageTotalPOIsPoints}
                />
                <TableHead>
                  <TableRow style={{ backgroundColor: "#cccccc" }}>
                    <TableCell colSpan={6}>Time Calculations</TableCell>
                  </TableRow>
                </TableHead>
                <TableBody>
                  <TableRow>
                    <TableCell>Start time</TableCell>
                    <TableCell></TableCell>
                    <TableCell></TableCell>
                    <TableCell></TableCell>
                    <TableCell align="right">
                      {journeyData?.ResultData &&
                        formatDate(journeyData?.ResultData?.StartedOnUtc)}
                    </TableCell>
                    <TableCell></TableCell>
                  </TableRow>
                  <TableRow>
                    <TableCell>End Time</TableCell>
                    <TableCell></TableCell>
                    <TableCell></TableCell>
                    <TableCell></TableCell>
                    <TableCell align="right">
                      {journeyData?.ResultData &&
                        formatDate(journeyData?.ResultData?.FinishedOnUtc)}
                    </TableCell>
                    <TableCell></TableCell>
                  </TableRow>
                  <TableRow>
                    <TableCell>Driving Time</TableCell>
                    <TableCell></TableCell>
                    <TableCell></TableCell>
                    <TableCell></TableCell>
                    <TableCell align="right">
                      {journeyData?.ResultData?.DrivingTime}
                    </TableCell>
                    <TableCell></TableCell>
                  </TableRow>
                  <TableRow>
                    <TableCell>Joker Time</TableCell>
                    <TableCell></TableCell>
                    <TableCell></TableCell>
                    <TableCell></TableCell>
                    <TableCell align="right">
                      {journeyData?.ResultData?.JokerTime}
                    </TableCell>
                    <TableCell></TableCell>
                  </TableRow>
                  <TableRow>
                    <TableCell>Pause time</TableCell>
                    <TableCell></TableCell>
                    <TableCell></TableCell>
                    <TableCell></TableCell>
                    <TableCell align="right">
                      {journeyData?.ResultData?.PauseTime}
                    </TableCell>
                    <TableCell></TableCell>
                  </TableRow>
                  <TableRow>
                    <TableCell>Credit Time</TableCell>
                    <TableCell></TableCell>
                    <TableCell></TableCell>
                    <TableCell></TableCell>
                    <TableCell align="right">
                      {journeyData?.ResultData?.CreditTime}
                    </TableCell>
                    <TableCell></TableCell>
                  </TableRow>
                  <TableRow>
                    <TableCell>Early start time</TableCell>
                    <TableCell align="right">
                      {journeyData?.ResultData?.EarlyStartTime}
                    </TableCell>
                    <TableCell></TableCell>
                    <TableCell>Early Start Penalty Time</TableCell>
                    <TableCell align="right">
                      {journeyData?.ResultData?.EarlyStartPenaltyTime}
                    </TableCell>
                    <TableCell></TableCell>
                  </TableRow>
                  <TableRow>
                    <TableCell>Ideal time duration</TableCell>
                    <TableCell align="right">
                      {journeyData?.ResultData?.EarlyIdealTime}
                    </TableCell>
                    <TableCell></TableCell>
                    <TableCell>Early Start Penalty Time</TableCell>
                    <TableCell align="right">
                      {journeyData?.ResultData?.EarlyStartPenaltyTime}
                    </TableCell>

                    <TableCell></TableCell>
                  </TableRow>
                  <TableRow>
                    <TableCell>Final Time</TableCell>
                    <TableCell></TableCell>
                    <TableCell></TableCell>
                    <TableCell></TableCell>
                    <TableCell align="right">
                      {journeyData?.ResultData?.FinalRankingTime}
                    </TableCell>
                    <TableCell></TableCell>
                  </TableRow>
                  <TableRow style={{ backgroundColor: "#f2f2f2" }}>
                    <TableCell>Time Points</TableCell>
                    <TableCell></TableCell>
                    <TableCell></TableCell>
                    <TableCell></TableCell>
                    <TableCell></TableCell>
                    <TableCell align="right">
                      {journeyData?.ResultData?.PointsOnTimeRank.toFixed(2)}
                    </TableCell>
                  </TableRow>
                </TableBody>
                <TableHead>
                  <TableRow style={{ backgroundColor: "#cccccc" }}>
                    <TableCell colSpan={6}>Total Points</TableCell>
                  </TableRow>
                </TableHead>
                <TableBody>
                  <TableRow>
                    <TableCell>Distance Points</TableCell>
                    <TableCell></TableCell>
                    <TableCell></TableCell>
                    <TableCell></TableCell>
                    <TableCell align="right">
                      {journeyData?.ResultData?.PointsOnDistanceRank.toFixed(2)}
                    </TableCell>
                    <TableCell></TableCell>
                  </TableRow>
                  <TableRow>
                    <TableCell>Time Points</TableCell>
                    <TableCell></TableCell>
                    <TableCell></TableCell>
                    <TableCell></TableCell>
                    <TableCell align="right">
                      {journeyData?.ResultData?.PointsOnTimeRank.toFixed(2)}
                    </TableCell>
                    <TableCell></TableCell>
                  </TableRow>
                  <TableRow>
                    <TableCell>Credit Points</TableCell>
                    <TableCell></TableCell>
                    <TableCell></TableCell>
                    <TableCell></TableCell>
                    <TableCell align="right">
                      {journeyData?.ResultData?.CreditPoints.toFixed(2)}
                    </TableCell>
                    <TableCell></TableCell>
                  </TableRow>
                  <TableRow>
                    <TableCell>Pois Points</TableCell>
                    <TableCell></TableCell>
                    <TableCell></TableCell>
                    <TableCell></TableCell>
                    <TableCell align="right">
                      {stagePOIsTotalPoints.toFixed(2)}
                    </TableCell>
                    <TableCell></TableCell>
                  </TableRow>
                  <TableRow style={{ backgroundColor: "#f2f2f2" }}>
                    <TableCell>Total Points</TableCell>
                    <TableCell></TableCell>
                    <TableCell></TableCell>
                    <TableCell></TableCell>
                    <TableCell></TableCell>
                    <TableCell align="right">
                      {journeyData?.ResultData?.FinalPoints.toFixed(2)}
                    </TableCell>
                  </TableRow>
                </TableBody>
              </Table>
            </TableContainer>
          )}
          {notificationDetailsVisible && (
            <TableContainer component={Paper}>
              <Table
                sx={{ minWidth: 400 }}
                size="small"
                aria-label="notifications table"
              >
                <TableHead>
                  <TableRow>
                    <TableCell>Title</TableCell>
                    <TableCell>POIs</TableCell>
                    <TableCell>Created On</TableCell>
                    <TableCell>Sent On</TableCell>
                  </TableRow>
                </TableHead>
                <TableBody>
                  {journeyData?.Notifications != null &&
                  journeyData?.Notifications?.SummaryData != null &&
                  journeyData?.Notifications?.SummaryData.length > 0 ? (
                    journeyData?.Notifications?.SummaryData.map(
                      (row, index) => (
                        <TableRow key={index}>
                          <TableCell>{row.Title}</TableCell>
                          <TableCell>{row.Pois}</TableCell>
                          <TableCell>{row?.["Created On"]}</TableCell>
                          <TableCell>{row?.["Sent On"]}</TableCell>
                        </TableRow>
                      )
                    )
                  ) : (
                    <TableRow>
                      <TableCell colSpan={4}>No Notifications Yet!</TableCell>
                    </TableRow>
                  )}
                </TableBody>
              </Table>
            </TableContainer>
          )}
          {poisDetailsVisible && (
            <TableContainer component={Paper}>
              <Table
                sx={{ minWidth: 400 }}
                size="small"
                aria-label="acquired pois table"
              >
                <TableHead>
                  <TableRow>
                    <TableCell>POI Name</TableCell>
                  </TableRow>
                </TableHead>
                <TableBody>
                  {journeyData.CurrentStagePoisList != null &&
                  journeyData.CurrentStagePoisList.length > 0 ? (
                    journeyData.CurrentStagePoisList.map((row, index) => (
                      <TableRow key={index}>
                        <TableCell>{row}</TableCell>
                      </TableRow>
                    ))
                  ) : (
                    <TableRow>
                      <TableCell>No POIs Aquaired Yet!</TableCell>
                    </TableRow>
                  )}
                </TableBody>
              </Table>
            </TableContainer>
          )}
        </AccordionDetails>
      </Accordion>
    </div>
  );
}

export default TeamDetails;
